import { makeRequest } from "@/shared/api/baseApi";
import {
  makeFolderCacheName,
  normalizeLanguageFolders
} from "@/shared/api/content/languages/utils";

export const getFoldersRequest = (lang) =>
  makeRequest({
    url: `/content/languages/${lang}/folders`,
    storageCacheName: makeFolderCacheName(lang),
    parseResponse: (response) => normalizeLanguageFolders(response.data, lang).outList,
  });
